import { render } from "./menu-shelf-linklist.vue?vue&type=template&id=122dcceb"
import script from "./menu-shelf-linklist.vue?vue&type=script&lang=js"
export * from "./menu-shelf-linklist.vue?vue&type=script&lang=js"

import exportComponent from "/Users/andrewamistad/Sites/lyle-and-scott/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__